import React, { useState } from 'react';
import {AddAttributeValues,UpdateAttributeValue} from '../Services/AttributeValuesService';

const AddAttributeValue = ({ onClose, attributeValue, productAttributeId}) => {

  const isEdit = !!attributeValue;

  const [formData, setFormData] = useState({
    name: attributeValue?.name || '',
    increasePrice: attributeValue?.increasePrice || '',
    productAttributeId: attributeValue?.productAttributeId || productAttributeId,
  });

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    console.log('Form Submitted:', formData);
    let res;
    if (isEdit) {
      res = await UpdateAttributeValue(attributeValue.id, formData);
    } else {
      res = await AddAttributeValues(formData);
    }
    if (res?.status) {
      handleClose();
    } else {
      alert(`Failed to ${isEdit ? 'update' : 'add'} category. Please try again.`);
    }
  };

  // Correct handleClose
  const handleClose = () => {
    onClose();
  };

  return (
    <div className="add-category-modal">
      <form className="add-category-form" onSubmit={handleSubmit}>
        <div className="header">
          <h2 className="title">{isEdit ? 'Update Value' : "Add Value"}</h2>

          {/* Close Button */}
          <button
            type="button"
            className="close-btn"
            onClick={handleClose}
          >
            &times;
          </button>
        </div>

        <div className="form-content">
          <div className="form-group">
            <label htmlFor="name">Enter Name</label>
            <input
              type="text"
              id="name"
              name="name"
              value={formData.name}
              onChange={handleChange}
              placeholder="Enter Here"
              required
            />
          </div>

          <div className="form-group">
            <label htmlFor="increasePrice">Price Adjustment (Rs / Kg)</label>
            <input
              type="number"
              step="any"
              id="increasePrice"
              name="increasePrice"
              value={formData.increasePrice}
              onChange={handleChange}
              placeholder="Enter price adjustment (e.g. 5 or 20)"
            />
          </div>
        </div>

        <div className="footer">
          <button type="submit" className="submit-btn">
            {isEdit ? 'UPDATE VALUE' : 'ADD VALUE'}
          </button>
        </div>
      </form>
    </div>
  );
};

export default AddAttributeValue;
